/**
 * 顧客リストアイテムコンポーネント
 *
 * 顧客一覧の個別アイテム表示
 */

import { Box, Group, Stack, Text, Badge, ActionIcon } from "@mantine/core";
import { Pencil } from "lucide-react";
import { Customer } from "../../services/customerService";

interface CustomerListItemProps {
  customer: Customer;
  isSelected: boolean;
  onClick: () => void;
  onEdit: (e: React.MouseEvent) => void;
}

/**
 * 顧客リストアイテム
 */
export function CustomerListItem({
  customer,
  isSelected,
  onClick,
  onEdit,
}: CustomerListItemProps) {
  return (
    <Box
      onClick={onClick}
      p="sm"
      pl="md"
      style={{
        position: "relative",
        borderRadius: "8px",
        backgroundColor: isSelected
          ? "var(--mantine-color-blue-light)"
          : "transparent",
        cursor: "pointer",
        transition: "all 0.15s ease",
      }}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.backgroundColor =
            "var(--mantine-color-gray-light)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }}
    >
      {isSelected && (
        <Box
          style={{
            position: "absolute",
            left: "6px",
            top: "12px",
            bottom: "12px",
            width: "3px",
            borderRadius: "3px",
            backgroundColor: "var(--mantine-color-blue-filled)",
          }}
        />
      )}
      <Group justify="space-between" align="center" wrap="nowrap">
        <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
          <Text
            fw={500}
            c={isSelected ? "blue" : undefined}
            lineClamp={1}
            size="sm"
          >
            {customer.customerName}
          </Text>
          <Text size="xs" c="dimmed">
            ID: {customer.customerId}
          </Text>
        </Stack>

        <Stack gap="xs" align="flex-end">
          <Badge
            size="xs"
            variant="light"
            color={customer.status === "active" ? "green" : "gray"}
          >
            {customer.status === "active" ? "有効" : "無効"}
          </Badge>
          <ActionIcon
            variant="subtle"
            size="sm"
            color="gray"
            onClick={onEdit}
            aria-label="編集"
          >
            <Pencil size={14} />
          </ActionIcon>
        </Stack>
      </Group>
    </Box>
  );
}
